import React, { useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';

const Modal = ({ isOpen, onClose, title, children, size = 'md' }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-2xl',
    xl: 'max-w-3xl'
  };

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto font-cairo dir-rtl">
      {/* Premium Backdrop with Blur */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-[6px] transition-all duration-300 animate-fadeIn"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="flex min-h-screen items-center justify-center p-4 sm:p-6">
        <div
          className={`relative bg-white rounded-[2rem] shadow-2xl w-full ${sizeClasses[size]} max-h-[92vh] overflow-hidden flex flex-col border border-white/20 animate-scaleIn`}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header Section */}
          <div className="flex items-center justify-between p-6 sm:px-8 border-b border-gray-100 bg-grayish/20">
            <h3 className="text-xl font-bold text-main1 tracking-tight">
              {title}
            </h3>
            <button
              onClick={onClose}
              className="p-2.5 rounded-xl bg-grayish hover:bg-red-50 text-gray-400 hover:text-red-500 transition-all duration-200 group"
              aria-label="Close modal"
            >
              <FaTimes className="text-lg group-hover:rotate-90 transition-transform duration-300" />
            </button>
          </div>

          {/* Content Section */}
          <div className="flex-1 overflow-y-auto p-6 sm:px-8 custom-scrollbar">
            <div className="animate-fadeIn animate-delay-100">
              {children}
            </div>
          </div>

          {/* Optional Footer Space */}
          <div className="h-4 bg-transparent" />
        </div>
      </div>
    </div>
  );
};

export default Modal;
